export default __webpack_public_path__ + "static/media/lean-startup-for-corporates.5c8e8d06.svg";